export const OPD_PATIENTS_REFRESH_EVENT = "opd-patients-refresh";
export const PATH_LAB_DATA_UPDATED_EVENT = "path-lab-data-updated";

/** Notify Out Patient table listeners to reload (e.g. after new OPD appointment). */
export const notifyOpdPatientsRefresh = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(OPD_PATIENTS_REFRESH_EVENT));
};

/** Notify path lab / All Patients Test listeners to reload after results change. */
export const notifyPathLabDataUpdated = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(PATH_LAB_DATA_UPDATED_EVENT));
};
